export class PhoneContactDto {
  constructor(
    public name: string,
    public phone: string,
  ) {}
}
